import { Stack } from '@mui/material';
import { Image } from '../atoms/Image';
import { getPageTitle } from '../../utils/pageTitle';

type LoaderProps = {
  title?: string
};

export const Loader = ({ title }: LoaderProps) => {

  const pageTitle = getPageTitle({ title });
  return (
    <Stack alignItems="center">
      <h1>
        <Image
          src="/images/logo-melusine-light.png"
          alt={pageTitle}
          sx={{ margin: '2rem auto', marginTop: '5rem', height: '10rem' }}
        />
      </h1>
      <Image
        src="/images/loader.webp"
        alt="chargement ..."
        sx={{
          margin: '0 auto',
          height: '6rem',
          width: '6rem'
        }}
      />
    </Stack>
  );
};
